import { Heading, Tabs, Text } from '@workwhile/ui'
import { ContentEditor } from './ContentEditor'
import { QuizEditor } from './QuizEditor'
import { useEditorContext } from './hooks/useEditorContext'

export function EditorView() {
  const {
    metadata,
    quiz,
    tabValue,
    setTabValue,
    isGeneratingQuiz,
    position,
    location,
  } = useEditorContext()

  return (
    <>
      <Heading level={1}>{metadata?.title}</Heading>
      {position && <Text fontSize={18}>Position: {position}</Text>}
      {location && <Text fontSize={18}>Location: {location}</Text>}
      {(quiz && !isGeneratingQuiz) || (!quiz && isGeneratingQuiz) ? (
        <Tabs
          value={tabValue}
          onValueChange={setTabValue}
          tabs={[
            {
              value: 'content',
              label: 'Content',
            },
            {
              value: 'quiz',
              label: 'Quiz',
            },
          ]}
        >
          <Tabs.Content value={'content'}>
            <ContentEditor />
          </Tabs.Content>
          <Tabs.Content value={'quiz'}>
            <QuizEditor />
          </Tabs.Content>
        </Tabs>
      ) : (
        <ContentEditor />
      )}
    </>
  )
}
